import confetti from "canvas-confetti";

/**
 * 優勝の紙吹雪
 *
 * 画面上端から金色の紙片がゆっくり舞い降りる。
 * 派手に打ち上げず、しばらく続いてから静かに終わらせる。
 * 1セッションにつき1回だけ実行する。
 */

const PREFERS_REDUCED_MOTION = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const STORAGE_KEY = "champions-celebrated";
const DURATION = 8000;
// const COLORS = ["#fcc800", "#ffe26c", "#b28400", "#ffffff"];
const COLORS = ["#b28400", "#d8aa05", "#ee7302", "#452e10"];

const randomInRange = (min, max) => Math.random() * (max - min) + min;

/** 1セッションで実行済みかどうか。ストレージが使えない環境では毎回出す。 */
const hasCelebrated = () => {
	try {
		return window.sessionStorage.getItem(STORAGE_KEY) !== null;
	} catch (error) {
		return false;
	}
};

const markCelebrated = () => {
	try {
		window.sessionStorage.setItem(STORAGE_KEY, "1");
	} catch (error) {
		// プライベートモードなどでは記録できないが、演出自体は問題ない
	}
};

export const celebrate = () => {
	if (PREFERS_REDUCED_MOTION || hasCelebrated()) return;
	markCelebrated();

	const end = Date.now() + DURATION;

	const frame = () => {
		const left = end - Date.now();
		if (left <= 0) return;

		// 終わりに向かって量を減らし、自然に止める
		const ratio = left / DURATION;

		confetti({
			particleCount: 2,
			startVelocity: 0,
			ticks: Math.max(280, 560 * ratio),
			origin: { x: Math.random(), y: randomInRange(-0.2, 0) },
			colors: COLORS,
			shapes: ["square"],
			gravity: randomInRange(0.28, 0.45),
			scalar: randomInRange(0.4, 0.9),
			drift: randomInRange(-0.4, 0.4),
			disableForReducedMotion: true,
		});

		requestAnimationFrame(frame);
	};

	frame();
};

export default celebrate;
